import { type Ref } from "vue";
import { useComplexModelModelWithChanges } from "@/features/core-shared/composables/useComplexModelWithChanges";
import { useGeoCitiesMasterdata } from "@/features/masterdata/composables/useGeoCitiesMasterdata";
import type { City as GeoCity } from "@/types/generated/GeoMasterDataApi";

/**
 * Factory for the city field.
 *
 * @param cityCode - reactive ref of the city code from the data source
 */
export function useCityField(cityCode: Ref<string | undefined>) {
  const { geoCities } = useGeoCitiesMasterdata();

  const initialValue = computed<GeoCity | null>(() => {
    if (!cityCode.value) return null;
    return geoCities.value.find((c) => c.code === cityCode.value) ?? null;
  });

  const { model, hasChanges, isFilled, reset } = useComplexModelModelWithChanges<GeoCity | null>(initialValue);

  return {
    id: "location.city" as const,
    model,
    cities: geoCities,
    isRequired: true,
    hasChanges,
    isFilled,
    reset,
  };
}
